import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeBE } from "../const";

export const CONVERTER_LIBRARY_CODE: {
  CONVERTER_LIBRARY_LIMIT_EXCEEDED: MvnCodeBE;
  CONVERTER_LIBRARY_ONLY_ADAMIG_SUPPORTED: MvnCodeBE;
  CONVERTER_LIBRARY_SYNC_SOURCE_NOT_FOUND: MvnCodeBE;
  CONVERTER_LIBRARY_SYNC_CODE_NOT_SYNCED: MvnCodeBE;
  CONVERTER_LIBRARY_SYNC_UNSUPPORTED_VALUE: MvnCodeBE;
  CONVERTER_LIBRARY_SYNC_FAILED: MvnCodeBE;
} = {
  CONVERTER_LIBRARY_LIMIT_EXCEEDED: {
    status: 409,
    ko: "라이브러리 저장 한도를 초과했습니다.",
    en: "The library storage limit has been exceeded.",
  },
  CONVERTER_LIBRARY_ONLY_ADAMIG_SUPPORTED: {
    status: 400,
    ko: "이 작업은 ADaMIG 표준만 지원합니다.",
    en: "Only ADaMIG standards are supported for this operation.",
  },
  CONVERTER_LIBRARY_SYNC_SOURCE_NOT_FOUND: {
    status: 400,
    ko: "CDISC Library 동기화 대상을 찾을 수 없습니다. ({target})",
    en: "The CDISC Library sync target could not be found. ({target})",
  },
  CONVERTER_LIBRARY_SYNC_CODE_NOT_SYNCED: {
    status: 400,
    ko: "Term 동기화 전에 Codelist 가 먼저 동기화되어야 합니다. ({target})",
    en: "The codelist must be synced before its terms. ({target})",
  },
  CONVERTER_LIBRARY_SYNC_UNSUPPORTED_VALUE: {
    status: 400,
    ko: "CDISC Library 응답에 지원하지 않는 값이 있습니다. ({value})",
    en: "The CDISC Library response contains an unsupported value. ({value})",
  },
  CONVERTER_LIBRARY_SYNC_FAILED: {
    status: 400,
    ko: "CDISC Library 동기화에 실패했습니다. ({target})",
    en: "Failed to sync from the CDISC Library. ({target})",
  },
};

MvnCodeInitiate(CONVERTER_LIBRARY_CODE);
